import React from "react";

const Portfolio = () => {
    // 1. Array banaya taaki baar-baar copy paste na karna pade
    const portfolioImages = [
        { id: 1, src: "../assets/img/1.jpg", alt: "Portfolio 1" },
        { id: 2, src: "../assets/img/02.jpg", alt: "Portfolio 2" },
        { id: 3, src: "../assets/img/03.jpg", alt: "Portfolio 3" },
        { id: 4, src: "../assets/img/04.jpg", alt: "Portfolio 4" },
        { id: 5, src: "../assets/img/05.jpg", alt: "Portfolio 5" },
        { id: 6, src: "../assets/img/06.jpg", alt: "Portfolio 6" },
        { id: 7, src: "../assets/img/07.jpg", alt: "Portfolio 7" },
        { id: 8, src: "../assets/img/08.jpg", alt: "Portfolio 8" },
        { id: 9, src: "../assets/img/09.jpg", alt: "Portfolio 9" },
    ];

    return (
        <>
            {/* class ko badal kar className kiya */}
            <div className="Portfolio-main" id="Portfolio">
                <div className="container">
                    <div className="Portfolio-inner">
                        <div className="title1" data-aos="fade-right">
                            <div className="title-inner">
                                <span>Gallery</span>
                                <h2>Portfolio</h2>
                            </div>
                        </div>
                        <div className="Portfolio-item">
                            <div className="portfolio-item-inner">

                                {/* 2. .map() use karke saari images ko ek baar me render kiya */}
                                {portfolioImages.map((item) => (
                                    <div className="port-item" key={item.id}>
                                        <a href="#">
                                            <img src={item.src} alt={item.alt} />
                                        </a>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Portfolio;